<template>
  <div class="sceneDetail" v-if="scene">
    <div class="sceneDetail__background" :data-blur="isAnyDisclaimerOpen"><div class="bg" :style="{ backgroundImage: 'url(' + scene.backgroundImage + ')' }"></div></div>
    <div class="sceneDetail__info" :data-blur="isAnyDisclaimerOpen">
      <h2 v-html="scene.title" :class="scene.sceneId"></h2>
      <h3 v-if="scene.sceneId!='coming-soon'">{{sceneLabel}} {{calcIndex}}</h3>
      <p v-if="scene.detailLongDescription" v-html="scene.detailLongDescription"></p>
      <h4 v-if="scene.detailProducts"><strong>{{productsLabel}}: </strong><span>{{scene.detailProducts}}</span></h4>
      <div class="sceneDetail__cta">
        <a v-if="scene.interactive && isMobile.any"
           href="#"
           class="sceneDetail__cta__interactive"
           @click.prevent="openMobileDisclaimer">
          <icon-interactive></icon-interactive>
          {{interactive.openCta}}
        </a>
        <a v-else-if="scene.interactive && isInternetExplorer"
           href="#"
           class="sceneDetail__cta__interactive"
           @click.prevent="openExplorerDisclaimer">
          <icon-interactive></icon-interactive>
          {{interactive.openCta}}
        </a>
        <a v-else-if="scene.interactive"
           href="#"
           class="sceneDetail__cta__interactive"
           @click.prevent="openInteractiveDisclaimer">
          <icon-interactive></icon-interactive>
          {{interactive.openCta}}
        </a>
        <a v-if="scene.video"
           href="#"
           class="sceneDetail__cta__video"
           @click.prevent="openVideoDisclaimer">
          <icon-autoplay></icon-autoplay>
          {{video.openCta}}
        </a>
        <a @click="trackExternalLink"
           v-if="scene.subscribeCta"
           v-bind:href="scene.subscribeCta.href"
           class="sceneDetail__cta__subscribe"
           target="_blank">
          {{scene.subscribeCta.label}}
        </a>
      </div>
    </div>
    <transition name="disclaimerPopup">
      <div class="sceneDetail__disclaimer sceneDetail__disclaimer--video" v-if="isVideoDisclaimerOpen">
        <div class="sceneDetail__disclaimer__content">
          <icon-headphones v-if=""></icon-headphones>
          <span class="sceneDetail__disclaimer__title">{{video.popupTitle}}</span>
          <span class="sceneDetail__disclaimer__subtitle">{{video.popupDescription}}</span>
          <a class="sceneDetail__disclaimer__cta"
             @click.prevent="goToVideo(scene.slag)"
             :data-start="video.popupCtaStart">
            <span>{{video.popupCtaEnd}}</span>
          </a>
        </div>
      </div>
    </transition>
    <transition name="disclaimerPopup">
      <div class="sceneDetail__disclaimer sceneDetail__disclaimer--interactive" v-if="isInteractiveDisclaimerOpen">
        <div class="sceneDetail__disclaimer__content">
          <span class="sceneDetail__disclaimer__title">{{interactive.popupTitle}}</span>
          <span class="sceneDetail__disclaimer__subtitle">{{interactive.popupDescription}}</span>
          <a class="sceneDetail__disclaimer__cta"
             @click.prevent="goToInteractive(scene.slag)"
             :data-start="interactive.popupCtaStart">
            <span>{{interactive.popupCtaEnd}}</span>
          </a>
        </div>
      </div>
    </transition>
    <transition name="disclaimerPopup">
      <div class="sceneDetail__disclaimer sceneDetail__disclaimer--mobile" v-if="isMobileDisclaimerOpen" @click.prevent="closeDisclaimer()">
        <div class="sceneDetail__disclaimer__content">
          <!--icon-headphones v-if=""></icon-headphones-->
          <span class="sceneDetail__disclaimer__subtitle" v-html="interactive.mobileDisclaimer"></span>
        </div>
      </div>
    </transition>
    <transition name="disclaimerPopup">
      <div class="sceneDetail__disclaimer sceneDetail__disclaimer--explorer" v-if="isExplorerDisclaimerOpen" @click.prevent="closeDisclaimer()">
        <div class="sceneDetail__disclaimer__content">
          <span class="sceneDetail__disclaimer__subtitle" v-html="interactive.explorerDisclaimer"></span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import Headphones from './icons/Headphones';
  import Interactive from './icons/Interactive';
  import Autoplay from './icons/Autoplay';

  export default{
    props: ['item', 'index'],
    data(){
      return {
        sceneLabel: '',
        productsLabel: '',
        "interactive": {
          "openCta": "",
          "popupTitle": "",
          "popupDescription": "",
          "popupCtaStart": "",
          "popupCtaEnd": "",
          "mobileDisclaimer": "",
          "explorerDisclaimer": "",
          "closeMobileDisclaimerCta": ""
        },
        "video": {
          "openCta": "",
          "popupTitle": "",
          "popupDescription": "",
          "popupCtaStart": "",
          "popupCtaEnd": ""
        },
        sceneIndex: this.index,
        scene: this.item,
        isVideoDisclaimerOpen: false,
        isInteractiveDisclaimerOpen: false,
        isInternetExplorer: false,
        isExplorerDisclaimerOpen: false,
        isMobileDisclaimerOpen: false,
        isMobile: isMobile
      }
    },
    computed: {
      calcIndex(){
        return this.sceneIndex + 1;
      },
      isAnyDisclaimerOpen(){
        return this.isVideoDisclaimerOpen || this.isInteractiveDisclaimerOpen;
      }
    },
    methods: {
      openInteractiveDisclaimer(){
        this.isInteractiveDisclaimerOpen = true;
        this.isExplorerDisclaimerOpen = false;
        this.$store.state.interface.isVisible = false;
        this.$store.state.interface.isFooterVisible = false;
      },
      openMobileDisclaimer(){
        this.isMobileDisclaimerOpen = true;
        this.isExplorerDisclaimerOpen = false;
        this.$store.state.interface.isVisible = false;
        this.$store.state.interface.isFooterVisible = false;
      },
      openExplorerDisclaimer(){
        this.isExplorerDisclaimerOpen = true;
        this.isMobileDisclaimerOpen = false;
        this.$store.state.interface.isVisible = false;
        this.$store.state.interface.isFooterVisible = false;
      },
      openVideoDisclaimer(){
        this.isVideoDisclaimerOpen = true;
        this.isExplorerDisclaimerOpen = false;
        this.$store.state.interface.isVisible = false;
        this.$store.state.interface.isFooterVisible = false;
      },
      goToVideo(sceneId){
        this.isVideoDisclaimerOpen = false;
        this.$store.state.interface.isVisible = true;
        this.$store.state.interface.breadcrumbsOnly = true;
        var lang = this.$route.params.lang;
        switch(lang){
          case 'en':{
            this.$router.push('/' + lang + '/' + sceneId + '/guided-tour');
            break;
          }
          case 'it': {
            this.$router.push('/' + lang + '/' + sceneId + '/visita-guidata');
            break;
          }
          default: {
            this.$router.push('/' + lang + '/' + sceneId + '/guided-tour');
            break;
          }
        }
      },
      goToInteractive(sceneId){
        this.isInteractiveDisclaimerOpen = false;
        var lang = this.$route.params.lang;
        switch(lang){
          case 'en':{
            this.$router.push('/' + lang + '/' + sceneId + '/interactive-3d-mode');
            break;
          }
          case 'it': {
            this.$router.push('/' + lang + '/' + sceneId + '/modalita-3d-interattiva');
            break;
          }
          default: {
            this.$router.push('/' + lang + '/' + sceneId + '/interactive-3d-mode');
            break;
          }
        }
      },
      closeAnimation(){
        this.$store.state.hasApplicationLoaded = true;
      },
      closeDisclaimer(){
        this.isMobileDisclaimerOpen = false;
        this.isExplorerDisclaimerOpen = false;
        this.$store.state.interface.isVisible = true;
        this.$store.state.interface.isFooterVisible = true;
      },
      trackExternalLink(e) {
        var href = e.currentTarget.getAttribute('href');

        eventTracking.send({
          category: 'ExternalLink',
          value: 'Click',
          label: href
        });

      }
    },
    components: {
      'icon-headphones': Headphones,
      'icon-interactive': Interactive,
      'icon-autoplay': Autoplay
    },
    mounted(){
      var vm = this;
      var version = detectUA();

      if (version !== false) {
        vm.isInternetExplorer = true;
      }

      function detectUA(){
        //Detect IE
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
          // IE 10 or older => return version number
          return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }
        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
          // IE 11 => return version number
          var rv = ua.indexOf('rv:');
          return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }
        return false;
      }
    },
    created(){
      var vm = this;
      vm.sceneLabel = vm.$store.state.labels.sceneSelector.sceneLabel;
      vm.productsLabel = vm.$store.state.labels.sceneSelector.productsLabel;
      vm.interactive.openCta = vm.$store.state.labels.sceneSelector.interactive.openCta;
      vm.interactive.popupTitle = vm.$store.state.labels.sceneSelector.interactive.popupTitle;
      vm.interactive.popupDescription = vm.$store.state.labels.sceneSelector.interactive.popupDescription;
      vm.interactive.popupCtaStart = vm.$store.state.labels.sceneSelector.interactive.popupCtaStart;
      vm.interactive.popupCtaEnd = vm.$store.state.labels.sceneSelector.interactive.popupCtaEnd;
      vm.interactive.mobileDisclaimer = vm.$store.state.labels.sceneSelector.interactive.mobileDisclaimer;
      vm.interactive.explorerDisclaimer = vm.$store.state.labels.sceneSelector.interactive.explorerDisclaimer;
      vm.interactive.closeMobileDisclaimerCta = vm.$store.state.labels.sceneSelector.interactive.closeMobileDisclaimerCta;
      vm.video.openCta = vm.$store.state.labels.sceneSelector.video.openCta;
      vm.video.popupTitle = vm.$store.state.labels.sceneSelector.video.popupTitle;
      vm.video.popupDescription = vm.$store.state.labels.sceneSelector.video.popupDescription;
      vm.video.popupCtaStart = vm.$store.state.labels.sceneSelector.video.popupCtaStart;
      vm.video.popupCtaEnd = vm.$store.state.labels.sceneSelector.video.popupCtaEnd;
    },
    updated(){
      var vm = this;
      vm.sceneLabel = vm.$store.state.labels.sceneSelector.sceneLabel;
      vm.productsLabel = vm.$store.state.labels.sceneSelector.productsLabel;
      vm.interactive.openCta = vm.$store.state.labels.sceneSelector.interactive.openCta;
      vm.interactive.popupTitle = vm.$store.state.labels.sceneSelector.interactive.popupTitle;
      vm.interactive.popupDescription = vm.$store.state.labels.sceneSelector.interactive.popupDescription;
      vm.interactive.popupCtaStart = vm.$store.state.labels.sceneSelector.interactive.popupCtaStart;
      vm.interactive.popupCtaEnd = vm.$store.state.labels.sceneSelector.interactive.popupCtaEnd;
      vm.interactive.mobileDisclaimer = vm.$store.state.labels.sceneSelector.interactive.mobileDisclaimer;
      vm.interactive.explorerDisclaimer = vm.$store.state.labels.sceneSelector.interactive.explorerDisclaimer;
      vm.interactive.closeMobileDisclaimerCta = vm.$store.state.labels.sceneSelector.interactive.closeMobileDisclaimerCta;
      vm.video.openCta = vm.$store.state.labels.sceneSelector.video.openCta;
      vm.video.popupTitle = vm.$store.state.labels.sceneSelector.video.popupTitle;
      vm.video.popupDescription = vm.$store.state.labels.sceneSelector.video.popupDescription;
      vm.video.popupCtaStart = vm.$store.state.labels.sceneSelector.video.popupCtaStart;
      vm.video.popupCtaEnd = vm.$store.state.labels.sceneSelector.video.popupCtaEnd;
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SceneDetail.vue